import clsx from "clsx";
import { usePathname } from "next/navigation";
import { useApp } from "@/context/AppContext";
import useNavAnimation from "@/hooks/useNavAnimation";
import usePageType from "@/hooks/usePageType";
import Chevron from "../icon/chevron";
import Underline from "../svg/underline";

export default function MobileNav({ navLinks }) {
  const pathname = usePathname();
  const { isMapPage, isRecordPage, isStoryPage } = usePageType();
  const { isRouteChanging, isMobile, setIsMobileNavOpen } = useApp();

  const { nav } = useNavAnimation({
    isRouteChanging,
    isMapPage,
    isRecordPage,
    isStoryPage,
    isMobile,
    mediaQueryMotion: "(prefers-reduced-motion: no-preference) and (max-width: 1023px)",
    mediaQueryNoMotion: "(prefers-reduced-motion: reduce) and (max-width: 1023px)"
  });

  // Find the current nav link based on pathname
  const parts = pathname.split('/');
  const normalizedPath = parts.length > 3 ? parts.slice(0, 3).join('/') : pathname;
  const currentNavLink = navLinks.find(link => link.href === normalizedPath);
  const label = currentNavLink ? currentNavLink.label : 'Menu';
  const localUnderlineSize = currentNavLink?.underlineSize || "medium"
  const underlineScale = currentNavLink?.headerUnderlineScale || 1;
  const transformOrigin = currentNavLink?.headerUnderlineOrigin || "left center";
  

  return (
    <nav className={clsx("lg:hidden w-full h-full flex flex-col items-center justify-center t-colors pointer-events-auto -translate-y-[200%] absolute top-0")} ref={nav}>
      <button onClick={() => setIsMobileNavOpen(true)} className={clsx("heading-4-small relative flex flex-col items-center cursor-pointer")}>
        <span className="flex gap-(--space-4)">{label} <Chevron className="fill-theme" /></span>
        <Underline
          className="absolute w-full -bottom-(--space-4) pointer-events-none"
          size={localUnderlineSize}
          scale={underlineScale}
          transformOrigin={transformOrigin} 
          isHover={true}
          isActive={true}
        />
      </button>
      {/* <MobileNavOverlay isOpen={isOpen} setIsOpen={setIsMobileNavOpen} navLinks={navLinks} underlineSize={underlineSize} /> */}
    </nav>
  )

}
